import { ParQSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { PARQ_QUESTIONS } from "./helpers";

export default function Step1ParQ1({ userName, age, sex, parqResponses, setParqResponse }) {
  return (
    <div>
      <p
        className="text-sm text-center mb-3"
        style={{ color: "#2D2A24" }}
        data-testid="f2-welcome-text"
      >
        Hola <strong>{userName || "usuario"}</strong>, vamos a evaluar tu estado físico basal.
      </p>

      <div className="flex justify-center gap-2 mb-3" data-testid="f2-info-badges">
        {age && (
          <span
            className="text-[11px] px-3 py-1 rounded-lg font-semibold"
            style={{ background: "#E3F0F5", color: "#00628F" }}
          >
            {age} años
          </span>
        )}
        {sex && (
          <span
            className="text-[11px] px-3 py-1 rounded-lg font-semibold"
            style={{ background: "#E3F0F5", color: "#00628F" }}
          >
            {sex}
          </span>
        )}
      </div>

      <div className="text-center mb-3">
        <ParQSVG hasAlert={false} />
      </div>

      <p className="text-xs text-center mb-4" style={{ color: "#71644C" }}>
        Antes de las pruebas físicas, responde estas preguntas de seguridad.
      </p>

      {PARQ_QUESTIONS.slice(0, 4).map((q, i) => (
        <div key={i} className="mb-3">
          <p className="text-xs font-medium mb-1.5" style={{ color: "#2D2A24" }}>
            {i + 1}. {q}
          </p>
          <PillSelect
            options={["Sí", "No"]}
            value={parqResponses[i] === null ? "" : parqResponses[i] ? "Sí" : "No"}
            onChange={(v) => setParqResponse(i, v === "Sí")}
            testId={`parq-${i + 1}`}
            columns={2}
          />
        </div>
      ))}
    </div>
  );
}
